import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import Button from '../Button';
import { formatPercent } from '../../utils/shipmentsFormat';
import { Banner } from './Ui';

const TYPE_LABELS = { supplier: 'Dodavatel', customer: 'Zákazník', machine: 'Trenažér', orderBatch: 'Objednávka dílů' };
const TYPE_FIELDS = { supplier: 'supplierId', customer: 'customerId', machine: 'machineId', orderBatch: 'orderBatchId' };

// Suggested links to ERP records (supplier / customer / machine / order) with a one-click "Přiřadit".
const MatchSuggestions = ({ suggestions, readOnly, onAssign }) => {
  const [busyKey, setBusyKey] = useState('');
  const [error, setError] = useState('');
  const usable = (suggestions || []).filter((s) => TYPE_FIELDS[s.type] && Number.isInteger(Number(s.id)));
  if (usable.length === 0) return null;

  const assign = async (s) => {
    setBusyKey(`${s.type}:${s.id}`);
    setError('');
    try { await onAssign({ [TYPE_FIELDS[s.type]]: Number(s.id) }); } catch (err) { setError(err.message); } finally { setBusyKey(''); }
  };

  return (
    <section className="shp-card" aria-labelledby="shp-match-title">
      <h2 id="shp-match-title" className="shp-h2"><Sparkles size={18} color="#E53935" aria-hidden="true" /> Návrhy propojení</h2>
      {error && <Banner tone="bad">{error}</Banner>}
      <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 10 }}>
        {usable.map((s) => {
          const key = `${s.type}:${s.id}`;
          return (
            <li key={key} style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', border: '1px solid #E0E0E0', borderRadius: 10, padding: '10px 12px' }}>
              <div style={{ flex: '1 1 200px', minWidth: 0 }}>
                <div className="shp-small shp-muted">{TYPE_LABELS[s.type]} · shoda {formatPercent(s.score)}</div>
                <div className="shp-wrap" dir="auto" style={{ fontWeight: 600 }}>{s.name}</div>
                {Array.isArray(s.reasons) && s.reasons.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                    {s.reasons.map((r) => <span key={String(r)} className="shp-tag shp-wrap">{String(r)}</span>)}
                  </div>
                )}
              </div>
              {!readOnly && (
                <Button loading={busyKey === key} disabled={Boolean(busyKey)} onClick={() => assign(s)}
                  aria-label={`Přiřadit: ${TYPE_LABELS[s.type]} ${s.name}`}>Přiřadit</Button>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default MatchSuggestions;
